import { AudioRecordingService } from './AudioRecordingService';

export const audioRecordingService = new AudioRecordingService();
